import React from "react";

import { Accordion, AccordionSummary, Box, Grid, Skeleton } from "@mui/material";

const SkeletonItem = () => {
  return (
    <Accordion>
      <AccordionSummary>
        <Box className="w-full">
          <Grid container className="w-full" spacing={1} alignItems="center">
            <Grid item xs={1} md={1.5}>
              <Skeleton width={"100%"} height={30} animation="wave" />
            </Grid>
            {new Array(10).fill(",").map((_, index) => {
              return (
                <Grid item xs={1} key={`skeleton-grid-${index}`}>
                  <Skeleton width={"100%"} height={30} animation="wave" />
                </Grid>
              );
            })}
            <Grid item xs={1} md={0.5}>
              <div className="flex flex-col items-end space-y-2">
                <Skeleton variant="rounded" width={20} height={20} />
                <Skeleton variant="rounded" width={20} height={20} />
              </div>
            </Grid>
          </Grid>
        </Box>
      </AccordionSummary>
    </Accordion>
  );
};

const FlightListSkeleton = ({ count }: { count: number }) => {
  if (count > 10) return null;

  return (
    <div className="pt-[20px]">
      {count === 0 ? (
        <div className="flex items-center justify-between pb-[20px]">
          <Skeleton variant="rounded" width={100} height={25} />
          <Skeleton variant="rounded" width={100} height={25} />
        </div>
      ) : null}
      {new Array(6).fill("").map((_, i) => (
        <SkeletonItem key={`skeleton-item-${i}`} />
      ))}
    </div>
  );
};

export default React.memo(FlightListSkeleton);
